<div class="col-12 mt-2">
  <div class="col-12 border border-info rounded " #topDiv>
    <div class="col-12 flex" id="topGroup">
      <div class="col-2" id="multiselectDiv">
        <div class="ui-inputgroup flex" id="filterLabel">
          <button pButton class="theme-button noHover labelButton buttonColor p-1 border-round-left" type="button" label="Status/Category"></button>
          <p-multiSelect [options]="searchStatusList" [(ngModel)]="valueToSearchforStatus" [filter]="true"
            placeholder="Select status" optionLabel="label" (onChange)="applyOnchangeFilterCheck()">
        </p-multiSelect>
        </div>
      </div>
      <div class="col-4 flex" id="datePicker">
        <div class="ui-inputgroup col-6 flex p-0">
          <button pButton class="theme-button labelButton buttonColor border-round-left" type="button" label="From"></button>
          <p-calendar class="datePicker1" [(ngModel)]="statusfromDate" [disabled]="valueToSearchforStatus.length == 0"  [dateFormat]="dateFormat"></p-calendar>
        </div>
        <div class="ui-inputgroup col-6 flex p-0">
          <button pButton class="theme-button labelButton buttonColor border-round-left" type="button" label="To"></button>
          <p-calendar class="datePicker2" [minDate]="statusfromDate" [(ngModel)]="statustoDate"   [disabled]="valueToSearchforStatus.length == 0"  [dateFormat]="dateFormat"></p-calendar>
        </div>
      </div>
      <div class=" col-1 ui-inputgroup userIdLable">
        <button pButton icon="fa fa-search" label="Search" class="buttonsRound noHover shadow border-round" (click)="onApplyFilter()" [disabled]="valueToSearchforStatus.length == 0"></button></div>
      <div class=" col-1 ui-inputgroup userIdLable">
          <button pButton icon="fa fa-remove" class="buttonsRound noHover shadow border-round" (click)="clearTableData()" label="Clear"></button>
      </div>
      <div class="col-3">
        <div class="ui-inputgroup">
          <button pButton class="theme-button noHover labelButton border-round-left" type="button" [disabled]="true" label="Action"></button>
          <p-dropdown [options]="actionList" [(ngModel)]="valueToSearchforAction" [filter]="true" [disabled]="!getDisabledForAction()"
            placeholder="Select Action">
        </p-dropdown>
        </div>
      </div>
      <div class=" col-1 ui-inputgroup userIdLable">
        <button pButton class="buttonsRound noHover shadow border-round"  label="Go" [disabled]="!getDisabledForGoButton()"
        (click)="setActionsUpdate()"></button>
    </div>
      </div>
</div>


<div class="col-12" [ngStyle]="setWidthForSideBarActivation()">
  <p-table #dt [value]="runTrackLibrariesPagination" [columns]="scrollableCols" [loading]="loading" [style]="{'overflow':'visible', 'word-wrap': 'break-word'}"
  scrollHeight="300%" (sortFunction)="customSort($event)" [customSort]="true"
   selectionMode="multiple"  dataKey="libraryId"
   (onRowSelect)="addToSelectedRows($event)" (onRowUnselect)="removeFromSelectedMap($event)"
   [rows]="125" [scrollable]="true"
   [totalRecords]="runTrackLibrariesValsTotalRows.length" sortField="dueDateRawData"  [sortOrder]="1">
    <ng-template pTemplate="caption">
      <table  class="col-12" aria-describedby="table to format">
        <thead class="col-12">
          <th class="col-6 border-none">
            <label style="font-size: large;">Displayed Libs (Total Libs) : {{getRowsCount()}} ({{runTrackLibrariesValsTotalRows.length}})</label>
          </th>
          <th class="col-3 border-none">
            <em class="fa fa-search" ></em>
            <input type="text" pInputText size="40" placeholder="Global Filter" (input)="globalFilterforTrackLib($event.target.value)"
            [(ngModel)]="runPlanTrackFilterValue" style="width:auto">
            &nbsp;&nbsp;&nbsp;&nbsp;Selected Libs : {{getSelectedLibsInrows()}}
          </th>
        </thead>
      </table>
    </ng-template>
    <ng-template pTemplate="header"  let-columns>
      <tr >
      <ng-container *ngFor="let col of columns">
          <th scope="col" *ngIf="col.field == 'checkbox'"  style="width: 7rem;" >
            <input type="checkbox" [(ngModel)]="isSelected" (change)="getcheckBoxDataforAllRow($event)" style="width: 22px;height: 23px;"> {{col.header}}
          </th>
          <th scope="col" *ngIf="col.field != 'checkbox' && col.field != 'runspecs'" class="text-center" style="width: 10rem;" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
          <th scope="col" *ngIf="col.field == 'runspecs'" class="text-center" style="width: 11rem;" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
      </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
      <tr [pSelectableRow]="rowData"  [pSelectableRowIndex]="rowIndex" [ngStyle]="checkBoxHighlight(rowData)" >
        <ng-container *ngFor="let col of columns">
          <td *ngIf="col.field =='checkbox'" class="text-center" [ngStyle]="getStyle(col.field)">
            <input type="checkbox"  [(ngModel)]="rowData[col.field]"  (change)="getcheckBoxData(rowData,$event.target.checked)" style="width: 22px;height: 23px;" />
          </td>
          <td *ngIf="col.field !='checkbox' && col.field !='missingReads' && col.field !='runLaneInfoHistory'" [ngStyle]="getStyle(col.field)" class="text-center" >
            {{getTextCellValue(col.field, rowData)}}
            <label *ngIf="col.field == 'projectName' && rowData?.gxp"  class="m-0 font-bold text-danger">GxP</label>
            <em *ngIf="col.field == 'sampleName' && rowData?.cancellationRequested" class="font-bold text-primary">&nbsp;Cancelled</em>

          </td>
          <td *ngIf="col.field =='missingReads'" [ngStyle]="getStyle(col.field)" class="text-center" >
            {{abbreviateNumber(rowData[col.field])}}
          </td>
          <td *ngIf="col.field =='runLaneInfoHistory'"  [ngStyle]="getStyle(col.field)" style="text-align: -webkit-center;">
            <div style="white-space: pre-line"> {{getrowValueForRunLane(rowData)}}</div>
          </td>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr >
        <td [attr.colspan]="12" class="text-center">
          No records found
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr >
        <td [attr.colspan]="14" class="text-center">
          <button pButton label="More" style="width: 120px;border-radius: 5px;" icon="pi pi-arrow-down" [disabled]="isMoreButtonDisabled()" (click)="moreToshow()"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-sidebar [(visible)]="actionUpdateFlag" position="right" [autoZIndex]="true"  [modal]="false" (onHide)="sidenavClosed()"
  [style]="{'width':'45em','top': '76px','padding-top': '3px','overflow': 'scroll','height':'91vh'}" styleClass="ui-sidebar-md">
      <h3 *ngIf=" valueToSearchforAction == 'UPDATE_CONSTRAINTS'" style="padding: 11px 0px; background-color: #e9ecef;">Update Run constraint</h3>
      <h3 *ngIf=" valueToSearchforAction == 'UPDATE_MISSINGREADS'" style="padding: 11px 0px; background-color: #e9ecef;">Update Target Reads</h3>
      <h3 *ngIf=" valueToSearchforAction == 'UPDATE_STATUS'" style="padding: 11px 0px; background-color: #e9ecef;">Confirmation</h3>
      <h3 *ngIf=" valueToSearchforAction == 'UPDATE_SEQUENCE'" style="padding: 11px 0px; background-color: #e9ecef;">Update Sequencing Specs</h3>
      <h3 *ngIf=" valueToSearchforAction == 'UPDATE_RAW_DATA_DELIVERY_DATE'" style="padding: 11px 0px; background-color: #e9ecef;">Update raw data delivery date</h3>

      <div *ngIf="constraintValidationList.length > 0">
      <h3 style="font-size: 1.3em;">Notice:</h3>
      <label  *ngFor="let notice of constraintValidationList" [innerHTML]="notice">
        {{notice}}<br />
      </label>
    </div>
    <div *ngIf="listOfTrackLibraries.length > 0 && !(valueToSearchforAction == 'UPDATE_STATUS')" >
      <label *ngIf="actionTypeMessage" [innerHTML]="actionTypeMessage">{{actionTypeMessage}}<br /> </label>
      <label class="font-bold" style="padding-left: 50px;" *ngFor="let trackLib of listOfTrackLibraries">
        {{getLibwithProjectName(trackLib)}}<br />
      </label>
      <label class="font-bold" style="padding-left: 50px;" *ngIf="truncateBooleanFlag">
      <pre> {{truncateStr}}</pre><br />
      </label>
      <label class="font-bold" style="margin-left: -48px;" *ngIf="lastIndexofTrackLib && truncateBooleanFlag">
        <br />{{lastIndexofTrackLib}}
      </label>
      <label class="font-bold" style="padding-left: 50px;" *ngIf="lastIndexofTrackLib && !truncateBooleanFlag">
        {{lastIndexofTrackLib}}
       </label><br />
       <label *ngIf="valueToSearchforAction == 'UPDATE_CONSTRAINTS'">Please select a constraint type and a unique constraint id to complete the update: </label>
       <label *ngIf="valueToSearchforAction == 'UPDATE_MISSINGREADS'">Please insert the required amount of reads:</label>
       <label *ngIf="valueToSearchforAction == 'UPDATE_SEQUENCE'">Please update the respective specification attribute* as required:</label>
      </div>
  <div class="threshold" style="margin-top: 0px;" *ngIf="listOfTrackLibraries.length>0 && valueToSearchforAction == 'UPDATE_CONSTRAINTS'">
    <label class="font-bold">Constraint</label>
    <div>
      <label>constraint Type</label>
      <div>
        <p-dropdown [style]="{'width':'15em', 'maxWidth':'15em'}" [options]="constraintTypeOptions"
          [(ngModel)]="selectedConstraintType" placeholder="Select" (onChange)="checkValueForconstraintID($event.value)">
        </p-dropdown>
      </div>
    </div>
    <div><br />
      <label>constraint Id</label>
      <div *ngIf="showinputOnLoad">
        <input pInputText class="form-control" [disabled]="istextDisabled()" [(ngModel)]="enteredConstraintId">
      </div>
      <div *ngIf="!showinputOnLoad">
        <p-dropdown [style]="{'width':'15em', 'maxWidth':'15em'}" [options]="productIdsOptions" [(ngModel)]="enteredConstraintId"
        placeholder="Select">
      </p-dropdown>
      </div>
    </div>
  </div>
  <div class="threshold" style="height: 116px;margin-top: 0px" *ngIf="listOfTrackLibraries.length > 0 && valueToSearchforAction == 'UPDATE_MISSINGREADS'">
    <label class="font-bold">New value for Missing Reads</label><br />
    <div>
        <input pInputText type="number" class="form-control" style="width: 300px;"
           [(ngModel)]="enteredMissingReads" >
    </div>
    <div style="padding-left: 3px;margin-top: 8px;">
      <label *ngIf="enteredMissingReads" style="word-break:break-word;">Missing Reads preview : {{abbreviateNumber(enteredMissingReads)}}</label>
    </div>
  </div>
  <div *ngIf="listofLibrariesWithoutTruncate.length>0 && valueToSearchforAction == 'UPDATE_STATUS'">
    <label *ngIf="actionTypeMessage" [innerHTML]="actionTypeMessage">{{actionTypeMessage}}</label><br />
      <ul>
        <li *ngFor="let item of listOfTagUntagStr" [innerHTML]="item">{{item}}</li>
      </ul>
    <label>as express libraries.</label><br />
    <label>Please confirm or reject the change.</label>
  </div>

  <div *ngIf="listofLibrariesWithoutTruncate.length > 0 && valueToSearchforAction == 'UPDATE_SEQUENCE'">
    <div class="ui-inputgroup" style="margin-top: 11px;">
      <button pButton class="theme-button labelButton" type="button" label="Sequencer"></button>
      <p-dropdown [style]="{'width':'15em', 'maxWidth':'15em'}" [options]="sequencerOptions" [(ngModel)]="selectedSequencerType"
      placeholder="Select a Sequencer"></p-dropdown>
    </div>
    <div style="width:380px;margin-top: 40px;">
    <p-fieldset legend="Read modes" >
      <div class="col">
          <div class="col-12">
            <button pButton class="theme-button noHover" type="button" label="Mode"></button>
            <p-dropdown [options]="capabilityModeOptions" [filter]="true" placeholder="Select" optionLabel="label"
              [showClear]="true" [(ngModel)]="selectedCapabilityMode"></p-dropdown>
          </div>
          <div class="col-12">
            <button pButton class="theme-button noHover" type="button" label="Length"></button>
            <input pInputText type="number" step="1" min="1" style="width: 5.8rem;" [(ngModel)]="capabilityLength">
            <label> bases </label>
          </div>
      </div>
    </p-fieldset></div><br />
    <label>*Empty input fields are omitted while updating.</label>
  </div>

    <div *ngIf="listofLibrariesWithoutTruncate.length>0 && valueToSearchforAction == 'UPDATE_RAW_DATA_DELIVERY_DATE'">
      <div class="col-12">
        <div class="ui-inputgroup col-2 p-0" style="width: 41%;margin: 5px;">
          <button pButton class="theme-button labelButton buttonColor" type="button" label="To"></button>
          <p-calendar class="datePicker2"  [(ngModel)]="updateRawDataDeliveryDate"   [disabled]="statusCountForValidation"  [dateFormat]="dateFormat" [style]="{'min-width':'155%'}" [inputStyle]="{'width':'70%','height':'0%'}"></p-calendar>
        </div>
      </div>
  </div>
<div class="col-12 flex">
  <div class="col-6" *ngIf="listOfTrackLibraries.length>0">
    <button pButton label="Reject" class="buttonsRound noHover shadow buttonPadding" [disabled]="submitDisabledIf()"
      (click)="rejectUpdate()"></button>
  </div>
  <div class="col-6 flex justify-content-end" *ngIf="listOfTrackLibraries.length>0">
    <button pButton label="Submit" class="buttonsRound noHover shadow buttonPadding" [disabled]="submitDisabledIf()"
      (click)="submitUpdate()"></button>
  </div>
</div>

  <div *ngIf = "erroMessageAfterUpdateFailed != ''" class="mt-5">
    <label class="m-0 text-danger" [innerHTML] = "erroMessageAfterUpdateFailed"></label>
  </div>

  </p-sidebar>
    <p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="10000" [closable]="false"></p-confirmDialog>
  </div>
</div>

<p-blockUI [blocked]="blocked" >
  <div>
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
